<div class="main">
    <h2 translate>home.lblAckWaitingList</h2>
    <div class="dx-fieldset">
        <dx-tree-view [dataSource]="ackWaitingTree" dataStructure="plain" showCheckBoxesMode="normal"
                      keyExpr="id" parentIdExpr="parentId" itemTemplate="itemTemplate" expandedExpr="expanded"
                      (onItemSelectionChanged)="selectionChanged($event)">
            <div *dxTemplate="let itemObj of 'itemTemplate'">
                <span>{{itemObj.text}}</span>
                <em *ngIf="itemObj.subText"><br/>{{itemObj.subText}}</em>
            </div>
        </dx-tree-view>
    </div>
    <div class="center">
        <dx-button [text]="'_commons.disable' | translate" (onClick)="disableAlert()" [disabled]="isDisabled"></dx-button>
    </div>
</div>

<!-- Loading panel -->
<dx-load-panel [visible]="isLoadPanelVisible" [message]="'_commons.loading' | translate" [position]="{ of: '.app-content', boundary: '.app-content' }"></dx-load-panel>
